export default {
  path: '',
  component: {
    template: '<router-view :key="$route.fullPath" />'
  },
  children: [
    {
      path: '/custom_pages',
      name: 'custom_pages.index',
      component: require('./index').default,
      meta: {
        title: '自定义页面',
        navbar: 'el-icon-document-add',
        permission: 'custom_pages.read'
      }
    },
    {
      path: '/custom_pages/new',
      name: 'custom_pages.new',
      component: require('./new').default,
      meta: {
        title: '新建自定义页面',
        permission: 'custom_pages.create'
      }
    },
    {
      path: '/custom_pages/:id/edit',
      name: 'custom_pages.edit',
      component: require('./edit').default,
      meta: {
        title: '编辑自定义页面',
        permission: 'custom_pages.update'
      }
    },
    {
      path: '/custom_pages/:id/config_share',
      name: 'custom_pages.config_share',
      component: require('./config-share').default,
      meta: {
        title: '设置分享',
        permission: 'custom_pages.update'
      }
    }
  ]
}
